export const mutation_add_log = `
mutation addLog($tenantId: String, $aziendaId: Int, $level: String!, $message: String!, $stack: String, $area: String, $method: String, $version: String) {
    insert_log_one(object: {TenantId: $tenantId, AziendaId: $aziendaId, Level: $level, Message: $message, Stack: $stack, Area: $area, Method: $method, Version: $version}) {
        Id
    }
}`;